export default {
  LOGIN: "登录",
  LOGIN_USERNAME: "用户名",
  LOGIN_PASSWORD: "密码",
  LOGIN_CAPTCHA: "验证码",
  LOGIN_PHONRNUMBER:"账号/手机号",
  LOGIN_PHONRNCAPTCHA:"输入验证码",
  LOGIN_FORGOT_PASSWORD: "忘记密码?",
  LOGIN_LOGINING: "登录中",
  LOGIN_PLS_INPUT_USERNAME: "请输入用户名",
  LOGIN_PLS_INPUT_PASSWORD: "请输入密码",
  LOGIN_USERNAME_OR_PASSWORD_INCORRECT: "用户名或密码不正确",
  LOGIN_INCORRECT_USERROLE: "当前用户不允许登录Portal",

  NEW_PASSWORD:"新密码",
  CONFIRM_NEW_PASSWORD:"确认新密码",
  SETTING_CHANGE_PASSWORD: "更改密码",
  SETTING_CHANGE_AVATAR: "更换头像",
  SETTING_LOGOUT: "注销",

  BUTTON_ADD: "新增",
  BUTTON_EDIT: "编辑",
  BUTTON_DELETE: "删除",
  BUTTON_EXPORT: "导出",
  BUTTON_IMPORT: "导入",
  BUTTON_SEARCH: "查询",
};


// WEBPACK FOOTER //
// ./src/components/locale/lang/zh-CN.js